import * as React from "react";

export const ReloadFiltersIcon = (props: any) => (
  <svg
    width={18}
    height={18}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M.373 0v1.465l5 6.25v7.305l.996-.782.977-.742c.156.755.468 1.432.937 2.031a5.049 5.049 0 0 0 1.739 1.446c.69.351 1.432.527 2.226.527.899 0 1.732-.228 2.5-.684A4.865 4.865 0 0 0 16.564 15a4.814 4.814 0 0 0 .684-2.5c0-.898-.228-1.732-.684-2.5a4.865 4.865 0 0 0-1.816-1.816 4.813 4.813 0 0 0-2.5-.684c-.573 0-1.126.098-1.66.293a5.228 5.228 0 0 0-1.465.82v-.898l5-6.25V0H.373Zm1.426 1.25h10.898L8.205 6.875H6.291L1.799 1.25Zm4.824 6.875h1.25v1.953a4.78 4.78 0 0 0-.605 1.914l-.645.508V8.125Zm5.625.625c.677 0 1.302.17 1.875.508a3.82 3.82 0 0 1 1.367 1.367c.339.573.508 1.198.508 1.875s-.17 1.302-.508 1.875a3.821 3.821 0 0 1-1.367 1.367 3.62 3.62 0 0 1-1.875.508 3.62 3.62 0 0 1-1.875-.508 3.823 3.823 0 0 1-1.367-1.367 3.62 3.62 0 0 1-.508-1.875c0-.677.17-1.302.508-1.875a3.822 3.822 0 0 1 1.367-1.367 3.62 3.62 0 0 1 1.875-.508Z"
      fill="#424248"
    />
    <path
      d="M11.822 12.955 10.322 11h.81l1.12 1.508L13.364 11h.803l-1.501 1.955L14.248 15h-.811l-1.185-1.597-1.2 1.597h-.804l1.574-2.045Z"
      fill="#424248"
    />
  </svg>
);
